import { BaseApiService } from "@mirage/services/BaseApiService";
import { IEntityPageRequest } from "@shared/mirage/core/contracts/IEntityPageRequest";
import { IEntityPageResult } from "@shared/mirage/core/contracts/IEntityPageResult";
import { IErrorMessage } from "@shared/mirage/core/contracts/IErrorMessage";
import { CreateTrackedApplicationResponse, UpdateTrackedApplicationResponse } from "@shared/publicportal/contracts/ITrackedApplications";
import { TrackedApplicationPageRequestResult } from "@shared/publicportal/contracts/TrackedApplicationPageRequestResult";
import { IPppTrackedApplication } from "@shared/publicportal/entities/IPppTrackedApplication";
import { IPTrackedApplicationNotifications } from "@shared/publicportal/entities/IPTrackedApplicationNotifications";
import { ITrackedApplicationService } from "@shared/publicportal/services/ITrackedApplicationService";

export class TrackedApplicationService extends BaseApiService implements ITrackedApplicationService {
    constructor() {
        super("publicportal/tracked");
    }

    async getTracked(): Promise<IPppTrackedApplication[]> {
        const response = await this.httpInstance().get("/");
        return response.data;
    }

    async createTrackedApplication(tracked: Partial<IPppTrackedApplication>): Promise<CreateTrackedApplicationResponse> {
        const response = await this.httpInstance().post("/", tracked);
        return response.data;
    }

    async updateTrackedApplication(request: IPppTrackedApplication): Promise<UpdateTrackedApplicationResponse> {
        const response = await this.httpInstance().put(`/${request.id}`, request);
        return response.data;
    }

    async deleteTrackedApplication(id: number): Promise<IErrorMessage> {
        const response = await this.httpInstance().delete(`/${id}`);
        return response.data;
    }

    async pageRequest(request: IEntityPageRequest): Promise<IEntityPageResult<TrackedApplicationPageRequestResult>> {
        const response = await this.httpInstance().post("/pageRequest", request);
        return response.data;
    }

    async pageNotificationsRequest(request: IEntityPageRequest): Promise<IEntityPageResult<IPTrackedApplicationNotifications>> {
        const response = await this.httpInstance().post("/pageNotificationsRequest", request);
        return response.data;
    }
}
